import Link from "next/link";

interface ContactItemProps {
  name: string;
  street: string;
  city: string;
  email: string;
  phone: string;
  assistanceHours?: {
    weekday: string;
    time: string;
  }[];
}

const ContactItem: React.FC<ContactItemProps> = (props) => {
  const {
    name,
    street,
    city,
    email,
    phone,
    assistanceHours = [
      {
        weekday: "Monday - Friday",
        time: "8:30 am to 18:00 pm AEST",
      },
    ],
  } = props;
  return (
    <div>
      <h2 className="text-lg mb-3">{name}</h2>
      <p>{street},</p>
      <p>{city}</p>
      <p>
        Email:{" "}
        <Link
          href={`mailto:${email}`}
          target="_blank"
          rel="noreferrer"
          className="text-icon"
        >
          {email}
        </Link>
      </p>
      <p className="mb-6">
        Call us:{" "}
        <Link href={`Tel:${phone}`} className="mb-6 text-icon">
          {phone}
        </Link>
      </p>
      <label className="font-semibold">Assistance hours:</label>
      {assistanceHours.map((item) => {
        const { weekday, time } = item;
        return (
          <>
            <p>{weekday}</p>
            <p>{time}</p>
          </>
        );
      })}
    </div>
  );
};

export default ContactItem;
